import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  total: 0,
  error: "",
  message: "",
};

export const userTransactionsAction = createAsyncThunk(
  "user-transactions",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `/admins/api/user-transactions?p_user_id=${data?.p_user_id}&s_date=${data?.startDate}&e_date=${data?.endDate}&publisher_id=${data?.publisher_id}&app_id=${data?.app_id}&partner_id=${data?.partner_id}&page=${data?.page}&limit=${data?.limit}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userTransactionSlice = createSlice({
  name: "user-transactions",
  initialState,
  reducers: {
    resetData: (state) => {
      state.status = null;
      state.loading = false;
      state.data = [];
      state.total = 0;
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userTransactionsAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userTransactionsAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.total = action?.payload?.totalCount;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(userTransactionsAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetData } = userTransactionSlice.actions;

export const userTransactionReducer = userTransactionSlice.reducer;
